import React, { useEffect, useMemo, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import FieldSelect from "../../Components/FieldSelect"
import Button from '../../Components/Button'
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"

const initialSellerForm = {
    firmRegistrationType: '',
    bankDetails: {
        accountNo: '',
        accountName: '',
        ifscCode: '',
        branchName: '',
        bankName: ''
    },
    panCardNo: '',
    accountName: '',
    mobileNumber: '',
    accountAddress: {
        addressLine1: '',
        addressLine2: '',
        state: '',
        district: '',
        landMark: '',
        city: '',
        pinCode: ''
    },
    businessProof: '',
    rkId: '',
}
const firmTypes = [{ text: 'Sole Proprietorship', value: 'soleProprietorship' }, { text: 'Private Limited (PVT LTD)', value: 'privateLimited' }, { text: 'Public Limited (PLC)', value: 'publicLimited' }]
const StoreAccount = () => {

    const [loading, setLoading] = useState(true)
    const [imageSrc, setImageSrc] = useState()
    const [storeDetails, setStoreDetails] = useState(initialSellerForm)
    const [addressEdit, setAddressEdit] = useState(false)
    const dispatch = useDispatch()

    const formData = useMemo(() => {
        return { ...initialSellerForm, ...storeDetails, }
    }, [storeDetails])

    useEffect(() => {
        setLoading(true)
        API.get('/accounts/getAccountDetails').then((res) => {
            if (res.status === 200) {
                setStoreDetails(res.data.data)
                setLoading(false)
            }
        })
    }, [])

    const accountFormSchema = Yup.object().shape({
        firmRegistrationType: Yup.string().required("Firm Registration type is required"),
        bankDetails: Yup.object().shape({
            accountNo: Yup.string().required("Account Number is required"),
            accountName: Yup.string().required("Account Name is required"),
            ifscCode: Yup.string().required("IFSC Code is required"),
            branchName: Yup.string().required("Branch Name is required"),
            bankName: Yup.string().required("Bank Name is required")
        }),
        panCardNo: Yup.string().required("Pan Card Number is required"),
        accountName: Yup.string().required("Account name is required"),
        mobileNumber: Yup.string().required("Mobile Number is required"),
        accountAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line1 is required"),
            addressLine2: Yup.string().nullable(),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            landMark: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        businessProof: Yup.string().nullable(),
        rkId: Yup.string().required("RK Id is required")
    })

    const accountForm = useFormik({
        initialValues: formData,
        validateOnMount: true,
        validationSchema: accountFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            API.post('/accounts/updateSellerAccount', values).then((apiRes) => {
                if (apiRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Account updated successfully', type: 'success', active: true }))
                }
            })
        }
    })

    const uploadFile = (value) => {
        const file = value;
        const reader = new FileReader();

        reader.onload = (e) => {
            setImageSrc(e.target.result);
        };
        reader.readAsDataURL(file);
    }

    const getLocation = (value) => {
        if (value.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${value}`).then((pinRes) => {
                if (pinRes.status === 200) {
                    const location = pinRes.data.data
                    accountForm.setValues({ ...accountForm.values, accountAddress: { city: location?.city || '', district: location?.district || '', pinCode: location?.pinCode || '', state: location?.state || '' } })
                    setAddressEdit(true)
                }
            })
        } else if (value.length === 0) {
            accountForm.setValues({ ...accountForm.values, accountAddress: { city: '', district: '', pinCode: '', state: '', addressLine1: '', addressLine2: '' } })
            setAddressEdit(false)
        }
    }


    return (
        <>
            {
                loading ? 'Loading ...' : <motion.div className="h-[80vh] overflow-auto w-full items-center flex flex-col justify-center">
                    <motion.div className="text-black font-bold text-xl">
                        Update a seller account
                    </motion.div>
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1">
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Firm Name'} placeholder={'Firm Name'} fieldProps={accountForm.getFieldProps('accountName')} fieldHelper={accountForm.getFieldHelpers('accountName')} fieldMeta={accountForm.getFieldMeta('accountName')} edit={true} dataLoaded={true} />
                            <FieldInput label="RKID" placeholder={'RKID'} fieldProps={accountForm.getFieldProps('rkId')} fieldHelper={accountForm.getFieldHelpers('rkId')} fieldMeta={accountForm.getFieldMeta('rkId')} edit={true} dataLoaded={true} />
                            <FieldSelect label={'Firm Registration Type'} placeholder={'Firm Registration Type'} fieldProps={accountForm.getFieldProps('firmRegistrationType')} fieldHelper={accountForm.getFieldHelpers('firmRegistrationType')} fieldMeta={accountForm.getFieldMeta('firmRegistrationType')} edit={true} dataLoaded={true} options={firmTypes} />
                            <FieldInput label={'PAN Card No'} placeholder={'PAN Card no'} fieldProps={accountForm.getFieldProps('panCardNo')} fieldHelper={accountForm.getFieldHelpers('panCardNo')} fieldMeta={accountForm.getFieldMeta('panCardNo')} edit={true} dataLoaded={true} />
                            {/* <FieldInput type="file" label={'Business Proof'} placeholder={'Business Proof'} fieldProps={accountForm.getFieldProps('businessProof')} fieldHelper={accountForm.getFieldHelpers('businessProof')} fieldMeta={accountForm.getFieldMeta('businessProof')} edit={true} dataLoaded={true} onChange={(file) => uploadFile(file)} /> */}
                            {/* <motion.div className="flex px-5 flex-col w-full">
                                <label>Business Proof</label>
                                <input className="px-2 py-2 ring-1 my-1 rounded-md ring-[lightGrey]" type="file" onChange={uploadFile} />
                            </motion.div> */}
                            <FieldInput type="phone" label={'Firm Mobile Number'} placeholder={'Firm MobileNumber'} fieldProps={accountForm.getFieldProps('mobileNumber')} fieldHelper={accountForm.getFieldHelpers('mobileNumber')} fieldMeta={accountForm.getFieldMeta('mobileNumber')} edit={true} dataLoaded={true} />
                        </motion.div>
                        <motion.div className='flex w-full my-2  px-5'>
                            <p className='font-bold text-xl'>Bank Details</p>
                            <div></div>
                        </motion.div>
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Account Name'} placeholder={'Account Name'} fieldProps={accountForm.getFieldProps('bankDetails.accountName')} fieldHelper={accountForm.getFieldHelpers('bankDetails.accountName')} fieldMeta={accountForm.getFieldMeta('bankDetails.accountName')} edit={true} dataLoaded={true} />
                            <FieldInput label={'Bank Name'} placeholder={'Bank Name'} fieldProps={accountForm.getFieldProps('bankDetails.bankName')} fieldHelper={accountForm.getFieldHelpers('bankDetails.bankName')} fieldMeta={accountForm.getFieldMeta('bankDetails.bankName')} edit={true} dataLoaded={true} />
                            <FieldInput label={'Account No'} placeholder={'Account No'} fieldProps={accountForm.getFieldProps('bankDetails.accountNo')} fieldHelper={accountForm.getFieldHelpers('bankDetails.accountNo')} fieldMeta={accountForm.getFieldMeta('bankDetails.accountNo')} edit={true} dataLoaded={true} />
                            <FieldInput label={'IFSC Code'} placeholder={'IFSC Code'} fieldProps={accountForm.getFieldProps('bankDetails.ifscCode')} fieldHelper={accountForm.getFieldHelpers('bankDetails.ifscCode')} fieldMeta={accountForm.getFieldMeta('bankDetails.ifscCode')} edit={true} dataLoaded={true} />
                            <FieldInput label={'Branch Name'} placeholder={'Branch Name'} fieldProps={accountForm.getFieldProps('bankDetails.branchName')} fieldHelper={accountForm.getFieldHelpers('bankDetails.branchName')} fieldMeta={accountForm.getFieldMeta('bankDetails.branchName')} edit={true} dataLoaded={true} />
                        </motion.div>
                        <motion.div className='flex w-full my-2  px-5'>
                            <p className='font-bold text-xl'>Firm Address</p>
                            <div></div>
                        </motion.div>
                        <motion.div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2'>
                            <FieldInput label={'Pincode'} placeholder={'Pincode'} fieldProps={accountForm.getFieldProps('accountAddress.pinCode')} fieldHelper={accountForm.getFieldHelpers('accountAddress.pinCode')} fieldMeta={accountForm.getFieldMeta('accountAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                            <FieldInput label={'Address Line 1'} placeholder={'Address Line 1'} fieldProps={accountForm.getFieldProps('accountAddress.addressLine1')} fieldHelper={accountForm.getFieldHelpers('accountAddress.addressLine1')} fieldMeta={accountForm.getFieldMeta('accountAddress.addressLine1')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'Address Line 2'} placeholder={'Address Line 2'} fieldProps={accountForm.getFieldProps('accountAddress.addressLine2')} fieldHelper={accountForm.getFieldHelpers('accountAddress.addressLine2')} fieldMeta={accountForm.getFieldMeta('accountAddress.addressLine2')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'City'} placeholder={'City'} fieldProps={accountForm.getFieldProps('accountAddress.city')} fieldHelper={accountForm.getFieldHelpers('accountAddress.city')} fieldMeta={accountForm.getFieldMeta('accountAddress.city')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'District'} placeholder={'District'} fieldProps={accountForm.getFieldProps('accountAddress.district')} fieldHelper={accountForm.getFieldHelpers('accountAddress.district')} fieldMeta={accountForm.getFieldMeta('accountAddress.district')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'Landmark'} placeholder={'Landmark'} fieldProps={accountForm.getFieldProps('accountAddress.landMark')} fieldHelper={accountForm.getFieldHelpers('accountAddress.landMark')} fieldMeta={accountForm.getFieldMeta('accountAddress.landMark')} edit={addressEdit} dataLoaded={true} />
                            <FieldInput label={'State'} placeholder={'State'} fieldProps={accountForm.getFieldProps('accountAddress.state')} fieldHelper={accountForm.getFieldHelpers('accountAddress.state')} fieldMeta={accountForm.getFieldMeta('accountAddress.state')} edit={addressEdit} dataLoaded={true} />
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row w-full items-center justify-center">
                        <Button injectClass={'ring-1 ring-[black] rounded-full hover:bg-primeColor/10 cursor-pointer'} onClick={() => accountForm.submitForm()}>Update Account</Button>
                    </motion.div>
                </motion.div>
            }
        </>
    )
}

export default StoreAccount